module.exports = __webpack_public_path__ + "static/media/e0d80810-f7e3-4fea-8c57-ef8116f0465d.5a593cd8.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/Fonts/e0d80810-f7e3-4fea-8c57-ef8116f0465d.woff2
// module id = 89
// module chunks = 0